import { OfferedAsType, } from '@wix/bookings-uou-types';
export const isServiceOfferedAsPricingPlan = (paymentDto, isPricingPlanInstalled) => getOfferedAs(paymentDto, isPricingPlanInstalled).indexOf(OfferedAsType.PRICING_PLAN) >= 0;
export const isServiceConnectedToPricingPlan = (paymentDto) => !!(paymentDto.pricingPlanInfo &&
    paymentDto.pricingPlanInfo.pricingPlans &&
    paymentDto.pricingPlanInfo.pricingPlans.length);
export const getOfferedAs = (paymentDto, isPricingPlanInstalled) => {
    if (paymentDto.offeredAs.indexOf(OfferedAsType.ONE_TIME) >= 0 &&
        paymentDto.offeredAs.indexOf(OfferedAsType.PRICING_PLAN) >= 0) {
        if (paymentDto.pricingPlanInfo.pricingPlans.length === 0 ||
            !isPricingPlanInstalled) {
            return [OfferedAsType.ONE_TIME];
        }
    }
    return paymentDto.offeredAs;
};
//# sourceMappingURL=pricing-plan-helpers.js.map